































import FieldDate from './Date.vue';
import FieldDropdown from './Dropdown.vue';
import FieldMulti from './Multi.vue';
import FieldText from './Text.vue';
import FieldTextarea from './Textarea.vue';
import FieldToggle from '@/components/Toggle.vue';

export default {
  props: {
    title: String,
    value: [String, Number, Object, Array, Date, Boolean],
    params: {
      type: Object,
      default: () => ({}),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: () => 'text',
    },
  },
  components: {
    FieldDate,
    FieldDropdown,
    FieldMulti,
    FieldText,
    FieldTextarea,
    FieldToggle,
  },
};
